import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { useSelector } from 'react-redux';
import { iRootState } from '../redux/store';

const QuoteTotal = function QuoteTotal(): React.ReactElement {
  const quoteTotal = useSelector(
    (state: iRootState) => state.paymentTerms.quoteTotal
  );
  return (
    <Grid container justify='flex-end'>
      <Grid item xs={3}>
        <Typography>
          <FormattedMessage
            id='PaymentTerms.QuoteTotal'
            defaultMessage='Quote Total'
          />
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography>
          <FormattedNumber value={quoteTotal} style='currency' currency='USD' />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default QuoteTotal;
